import { useSnapshot } from 'valtio'
import { type ReactElement, useCallback, useEffect } from 'react'
import { globalUserProxy } from '../../../../proxies/globalUserProxy'
import MegaphoneIcon from '../../../ui/icons/MegaphoneIcon'
import XMarkIcon from '../../../ui/icons/XMarkIcon'
import { isLatestVersion } from './utils'

export function UpdateVersionBanner (): ReactElement {
  const { isVersionBannerDismissed, isVersionBannerDisplayed } = useSnapshot(globalUserProxy)
  const toggleDismissed = useCallback(
    () => { globalUserProxy.isVersionBannerDismissed = !globalUserProxy.isVersionBannerDismissed },
    []
  )

  useEffect(() => { void isLatestVersion() }, [])

  if (isVersionBannerDisplayed && !isVersionBannerDismissed) {
    return (
      <div className="bg-yellow-500">
        <div className="mx-auto max-w-7xl py-3 px-3 sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-center justify-between">
            <div className="flex w-0 flex-1 items-center">
              <span className="flex rounded-lg bg-std-dark-cool-gray-500 p-2">
                <MegaphoneIcon />
              </span>
              <p className="mx-auto truncate font-medium text-white">
                <span>Your version of the website is out of date. Click here to refresh the page.</span>
              </p>
            </div>
            <div className="order-3 mt-2 w-full flex-shrink-0 sm:order-2 sm:mt-0 sm:w-auto rounded-md border border-transparent bg-std-dark-cool-gray-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-std-dark-cool-gray-100">
              <button
                onClick={() => { window.location.reload() }}
              >
                Refresh
              </button>
            </div>
            <div className="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
              <button
                onClick={toggleDismissed}
                type="button"
                className="-mr-1 flex rounded-md p-2 hover:bg-std-dark-cool-gray-100 focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2"
              >
                <span className="sr-only">Dismiss</span>
                <XMarkIcon />
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
  return (<></>)
}
